import { useState } from "react";
import { Form, Input } from "antd";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";

import { useAlert } from "../../context/AlertProvider";
import { changeEmail } from "../../actionCreator/signUpActionCreater";

const ChangeEmail = ({ email, activationKey, callback }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showAlert } = useAlert();
  const [error, setError] = useState();

  const onChangeEmail = async (values) => {
    setError(null);
    const res = await dispatch(
      changeEmail({
        currentEmail: values?.currentEmail,
        newEmail: values?.newEmail,
        activationKey,
      }),
    );
    if (res?.status === 200) {
      navigate(`/signup?key=${activationKey}&email=${values?.newEmail}`);
      showAlert("success", "Your email has been successfully updated.");
      callback();
    }
    if (
      res.response &&
      res.response.status >= 400 &&
      res.response.status <= 500
    ) {
      showAlert("error", res?.response?.data?.title);
      setError(res?.response?.data?.title);
    }
  };

  return (
    <Form
      onFinish={onChangeEmail}
      className="mt10"
      initialValues={{ currentEmail: email, newEmail: "" }}
    >
      {error && <p className="text-error text-center pb-2">{error}</p>}
      <Form.Item
        name="currentEmail"
        rules={[
          {
            type: "email",
            message: "Please enter valid E-mail!",
          },
          { required: true, message: "Please enter current email." },
        ]}
      >
        <div className="d-flex flex-column">
          <label className="heading12px text-gray pb-1">
            Current Email<span className="text-error">*</span>
          </label>
          <Input
            placeholder="Enter Your Email"
            className="auth-input"
            defaultValue={email}
          />
        </div>
      </Form.Item>
      <Form.Item
        name="newEmail"
        rules={[
          {
            type: "email",
            message: "Please enter valid E-mail!",
          },
          { required: true, message: "Please enter new email." },
        ]}
      >
        <div className="d-flex flex-column">
          <label className="heading12px text-gray pb-1">
            New Email<span className="text-error">*</span>
          </label>
          <Input placeholder="Enter Your Email" className="auth-input" />
        </div>
      </Form.Item>
      <div className="d-flex" style={{ gap: "20px" }}>
        <Button
          className="secondary-btn mt-4"
          style={{ width: "100%" }}
          onClick={callback}
        >
          Cancel
        </Button>
        <Button
          type="primary"
          htmlType="submit"
          style={{ width: "100%" }}
          className="theme-btn mt-4"
        >
          Change Email
        </Button>
      </div>
    </Form>
  );
};

export default ChangeEmail;
